import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
var Alert = /*#__PURE__*/function (_Component) {
  function Alert(props) {
    var _this;
    _classCallCheck(this, Alert);
    _this = _callSuper(this, Alert, [props]);
    _this.state = {
      type: _this.props.hasOwnProperty('type') ? _this.props.type : ''
    };
    return _this;
  }
  _inherits(Alert, _Component);
  return _createClass(Alert, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        key: "notifications_alert_".concat(this.props.id),
        className: "card alert alert-".concat(this.props.type)
      }, this.props.children);
    }
  }]);
}(Component);
export { Alert as default };